import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';
import { Children, cloneElement } from '@wordpress/element';
import { Dropdown } from '@wordpress/components';
import PropTypes from 'prop-types';
import { withViewportMatch } from '@wordpress/viewport';
/**
 * Internal dependencies
 */

import Menu from './menu';
/**
 * A container element for a list of SummaryNumbers. This component handles detecting & switching to
 * the mobile format on smaller screens.
 *
 * @return { object } -
 */

var SummaryList = function SummaryList(_ref) {
  var children = _ref.children,
      isDropdownBreakpoint = _ref.isDropdownBreakpoint,
      label = _ref.label;
  var items = children({}); // We default to "one" because we can't have empty children.

  var itemCount = Children.count(items) || 1;
  var orientation = isDropdownBreakpoint ? 'vertical' : 'horizontal';
  var summaryMenu = createElement(Menu, {
    label: label,
    orientation: orientation,
    itemCount: itemCount,
    items: items
  }); // On large screens, or if there are not multiple SummaryNumbers, we'll display the plain list.

  if (!isDropdownBreakpoint || itemCount < 2) {
    return summaryMenu;
  }

  var selected = items.find(function (item) {
    return !!item.props.selected;
  });

  if (!selected) {
    return summaryMenu;
  }

  return createElement(Dropdown, {
    className: "woocommerce-summary",
    position: "bottom",
    headerTitle: label,
    renderToggle: function renderToggle(_ref2) {
      var isOpen = _ref2.isOpen,
          onToggle = _ref2.onToggle;
      return cloneElement(selected, {
        onToggle: onToggle,
        isOpen: isOpen
      });
    },
    renderContent: function renderContent(renderContentArgs) {
      return createElement(Menu, {
        label: label,
        orientation: orientation,
        itemCount: itemCount,
        items: children(renderContentArgs)
      });
    }
  });
};

SummaryList.propTypes = {
  /**
   * A function returning a list of `<SummaryNumber />`s
   */
  children: PropTypes.func.isRequired,

  /**
   * An optional label of this group, read to screen reader users.
   */
  label: PropTypes.string
};
SummaryList.defaultProps = {
  label: __('Performance Indicators', 'woocommerce-admin')
};
export default withViewportMatch({
  isDropdownBreakpoint: '< large'
})(SummaryList);
//# sourceMappingURL=index.js.map